export default __webpack_public_path__ + "static/media/GrinderImg.7f424af4.jpg";